// saaedaApi.js — thin wrapper around our backend proxy.
//
// The backend (career-saaeda-server) is the only thing that talks to
// Salesforce. The browser never holds a Salesforce token.

import axios from "axios";

// Single configurable base URL. Override via REACT_APP_API_BASE.
// In dev the base is empty so requests hit the CRA dev server, which proxies
// them to the backend (see "proxy" in package.json) — avoids CORS on localhost.
const API_BASE =
  process.env.REACT_APP_API_BASE ??
  (process.env.NODE_ENV === "development" ? "" : "https://career-api.saaeda.com");

const http = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// ---------- Reads ----------

export async function fetchVacancy(id) {
  const { data } = await http.get(`/api/v1/vacancy/${encodeURIComponent(id)}`);
  return data;
}

export async function fetchScreeningQuestions(vacancyId) {
  const { data } = await http.get(
    `/api/v1/vacancy/${encodeURIComponent(vacancyId)}/screening-questions`
  );
  return data;
}

// ---------- Writes (whitelisted objects on the backend) ----------

async function createSObject(objectApi, record) {
  const { data } = await http.post(
    `/api/v1/sobject/${encodeURIComponent(objectApi)}`,
    record
  );
  return data.id;
}

async function deleteSObject(objectApi, id) {
  await http.delete(
    `/api/v1/sobject/${encodeURIComponent(objectApi)}/${encodeURIComponent(id)}`
  );
}

export const createCandidate = (record) => createSObject("Candidates__c", record);
export const deleteCandidate = (id) => deleteSObject("Candidates__c", id);

export const createEducation = (record) => createSObject("Educations__c", record);
export const createExperience = (record) => createSObject("Experiences__c", record);
export const createLanguageSkill = (record) => createSObject("Candidate_Language_Skills__c", record);
export const createApplicationRecord = (record) => createSObject("First_Application__c", record);

export async function createScreeningAnswersComposite(records) {
  const { data } = await http.post(`/api/v1/composite/screening-answers`, {
    allOrNone: false,
    records,
  });
  return data;
}
